<template>
  <div class="input-container" :style="{ margin: margin, height: height }">
    <label :class="{ labelObrigatorio: campoVazio && required }">
      {{ label }}</label
    >
    <div v-if="temIcon" class="field">
      <div class="control has-icons-right">
        <input
          class="input"
          :id="id"
          :type="type"
          :required="required"
          :placeholder="placeholder"
          :value="modelValue"
          @input="($event) => habilitarOpcoes ? consultarQuandoParar($event) : setResult($event.target.value)"
          :maxlength="maxLength"
          autocomplete="off"
        />
        <div v-show="showHints">
          <ul v-show="!isLoading && showHints" class="autocomplete-results">
            <li
              v-for="result in results"
              :key="result"
              class="autocomplete-result"
            >
              {{ result }}
            </li>
          </ul>
          <span class="icon is-small is-right">
            <i class="mdi" :class="classIcon"></i>
          </span>
        </div>
      </div>
      <h3 v-if="isLoading && showHints" class="is-size-6 pl-2">
        Carregando...<span
          class="button is-loading is-trf-main-loading is-inline-block"
        ></span>
      </h3>
    </div>
    <div v-else>
      <input
        class="input"
        :type="type"
        :placeholder="placeholder"
        :id="id"
        :maxlength="maxLength"
        :required="required"
        :class="{ inValida: (campoVazio && required) || !isDataValida }"
        :value="modelValue"
        :disabled="isDisabled"
        @input="($event) => habilitarOpcoes ? consultarQuandoParar($event) : setResult($event.target.value)"
        autocomplete="off"
      />
      <div v-if="showHints">
        <h3 v-if="isLoading" class="is-size-6 pl-2">
          Carregando...<span
            class="button is-loading is-trf-main-loading is-inline-block"
          ></span>
        </h3>
        <ul v-show="!isLoading" class="autocomplete-results">
          <li
            v-for="result in results"
            @click="setResult(result)"
            :key="result"
            class="autocomplete-result"
          >
            {{ result }}
          </li>
        </ul>
      </div>
    </div>
    <span v-if="tipLabel" class="tip-label is-size-7">{{ tipLabel }}</span>

    <div class="mensagemDeErro" v-if="required">
      <span v-if="campoVazio && label != null" class="campo-obrigatório"
        >{{ label }} é obrigatório.</span
      >
      <span v-else-if="campoVazio && isDataValida" class="campo-obrigatório"
        >Campo obrigatório.</span
      >
      <span v-if="!isDataValida && type == 'date'" class="campo-obrigatório"
        >Formato de data inválido</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfAutocomplete",
  props: {
    label: String,
    placeholder: String,
    margin: String,
    height: String,
    temIcon: Boolean,
    classIcon: String,
    modelValue: {
      type: [String],
      default: ''
    },
    required: {
      type: Boolean,
      default: true,
    },
    id: String,
    maxLength: String,
    type: String,
    tipLabel: String,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    habilitarOpcoes: {
      type: [Boolean],
      default: true
    }
  },
  data() {
    return {
      campoVazio: true,
      isDataValida: true,
      search: "",
      results: [],
      timeout: new Date(),
      showHints: this.habilitarOpcoes,
    };
  },
  methods: {
    verificarSeInputEstaVazio() {
      if (this.type != "date") {
        this.campoVazio =
          this.modelValue.trim() == "" || this.modelValue === undefined;
        return this.campoVazio;
      }
    },

    verificarSeInputDoTipoDateEstaVazio() {
      const input = document.querySelector('input[type="date"]');
      if (
        !input.validity.badInput &&
        input.validationMessage &&
        input.value == ""
      ) {
        this.campoVazio = true;
        return this.campoVazio;
      } else if (input.validity.badInput || input.value != "") {
        this.campoVazio = false;
        return this.campoVazio;
      }
    },

    verificarSeDataEValida() {
      if (this.type == "date") {
        const inputDate = document.querySelector('input[type="date"]');
        this.verificarSeInputDoTipoDateEstaVazio();
        this.isDataValida =
          (inputDate.validationMessage && inputDate.validity.badInput) ||
          inputDate.value == ""
            ? false
            : true;
        if (!this.isDataValida) {
          inputDate.value = "";
        }
        return this.isDataValida;
      }
    },

    setResult(result) {
      this.$emit("update:modelValue", result);
      if (this.habilitarOpcoes) {
        this.showHints = false;
      }
      this.$nextTick().then(() => {
        this.verificarSeInputEstaVazio();
      })
    },
    consultarQuandoParar($event) {
      clearTimeout(this.timeout);
      this.$emit("update:modelValue", $event.target.value);
      this.timeout = setTimeout(() => {
        this.$emit("update:results", $event.target.value);
        if (this.habilitarOpcoes) {
          this.showHints = true;
        }
      }, 400);
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  watch: {
    items: function (val, oldValue) {
      if (val.length !== oldValue.length) {
        this.results = val;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";

.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.inValida {
  border: 1px solid var(--primaryColor, $primary) !important;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: var(--primaryColor, $primary) !important;
  font-size: 12px;
}
.labelObrigatorio {
  color: var(--primaryColor, $primary) !important;
}
.tip-label {
  color: #4a4a4a;
  vertical-align: top;
}
.autocomplete-results {
  padding: 0.5rem 0.75rem;
  margin: 0;
  border: 1px solid var(--borderColor, $border-color);
  height: 120px;
  min-height: 1em;
  max-height: 6em;
  margin-bottom: 5px;
  overflow: auto;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.autocomplete-result:hover {
  margin-bottom: 5px;
  background-color: var(--secondaryColor, $secondary) !important;
  color: var(--primaryColor, $primary) !important;
}

.is-trf-main-loading {
  background: transparent !important;
  border: 0 none transparent !important;
  outline: 0 none transparent !important;
  pointer-events: none !important;
  color: var(--primaryColor, $primary) !important;
}
.is-trf-main-loading::after {
  border-left-color: currentColor;
  border-bottom-color: currentColor;
}
</style>
